import { getRecentFilesList, FileListLoadingStatus } from 'owa-group-files-hub-store';
import { getRecentFilesFromCache, refreshRecentFiles } from 'owa-group-files-hub-actions';
import updateRecentFilesLoadingAndErrorStatus from 'owa-group-files-hub-store/lib/actions/updateRecentFilesLoadingStatus';

export default function getRecentFiles(groupSmtpAddress: string) {
    const recentFilesList = getRecentFilesList(groupSmtpAddress);

    // Update the fileListLoadingStatus in RecentFilesStore for that group

    updateRecentFilesLoadingAndErrorStatus(
        groupSmtpAddress,
        FileListLoadingStatus.Loading,
        '',
        false
    );

    if (recentFilesList.fileItems) {
        // only refresh the list if there are already some files in the store for that group.
        refreshRecentFiles(groupSmtpAddress);
    } else {
        updateRecentFilesLoadingAndErrorStatus(
            groupSmtpAddress,
            FileListLoadingStatus.Loading,
            '',
            true
        );

        getRecentFilesFromCache(groupSmtpAddress);
        refreshRecentFiles(groupSmtpAddress);
    }
}
